import { upsertSetting } from "../../features/settings/settingsSlice";
import { buildAuthUrl } from "../../features/oauth/oauthAPI";
import {
  createAuthState,
  openAuthLink,
} from "../AssistantDetails/Assistants.utils";

const updateSettingData = (setting, upsertData, updateSetting) => {
  const newSetting = { ...setting, ...upsertData };
  if (updateSetting) updateSetting(newSetting);
  return newSetting;
};

export const handleCustomPlatformAuth = async ({
  assistantId,
  setting,
  dispatch,
  updateSetting,
  platformType,
  user,
  isConfigRequired,
  isOnboarding
}) => {
  //TODO: User check is missing do we need that.

  if (platformType === "none") {
    if (!setting) {
      console.error("No existing setting found");
      return;
    }
    const upsertData = {
      uuid: setting.uuid,
      accountId: setting.accountId || setting.org,
      userId: setting.userId,
      assistantId,
      phoneNumber: setting.phoneNumber,
      isInstallationCompleted: true,
    };

    try {
      await dispatch(
        upsertSetting({
          uuid: assistantId,
          data: upsertData,
        }),
      );

      const newSetting = updateSettingData(setting, upsertData, updateSetting);

      return { data: null, newSetting };
    } catch (err) {
      console.error("Failed to update setting:", err);
    }
    return;
  }

  const state = createAuthState(user, assistantId, isConfigRequired, isOnboarding);

  try {
    openAuthLink(buildAuthUrl(assistantId, state));
    return;
  } catch (error) {
    console.warn("Failed to fetch profile, redirecting to auth...");
  }
};
